import React from "react";
import DropDeskIcon from "@dropDesk/storage/icons";
import {
    TableRow,
    TableCell,
    ProductCellContent,
    ProductIconWrapper,
    ProductTextBlock,
    ProductName,
    DescriptionText,
    StatusBadge,
    ValueText,
    ActionButton,
    ActionCellContent,
} from "../styled";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {formatCurrency} from "@dropDesk/utils/helpers/common";


const SubscriptionOverviewRow = (props: {
    statusAndButton: { status: React.ReactNode; button: React.ReactNode }
    type: string
    iconType: string
    productName: string
    productDescription: string
    productDescriptionColor?: string
    nextDueDate: string
    value: number
    valueText?: string
    valueLabel?: string
    valueNote?: string
}) => {
    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;


    return (
        <TableRow borderColor={colors.border} background={colors.onBackground}>
            <TableCell color={colors.text}>
                <ProductCellContent>
                    <ProductIconWrapper background={`${colors.accent}12`} color={colors.accent}>
                        <DropDeskIcon icon={props.iconType} size={15} color={colors.accent}/>
                    </ProductIconWrapper>
                    <ProductName color={colors.text}>{props.type}</ProductName>
                </ProductCellContent>
            </TableCell>
            <TableCell color={colors.hint}>
                <ProductTextBlock>
                    <ProductName color={colors.text}>{props.productName}</ProductName>
                    <DescriptionText color={props.productDescriptionColor ?? colors.hint}>
                        {props.productDescription}
                    </DescriptionText>
                </ProductTextBlock>
            </TableCell>
            <TableCell color={colors.text}>
                {props.statusAndButton.status}
            </TableCell>
            <TableCell color={colors.text}>
                <DescriptionText color={colors.text}>{props.nextDueDate}</DescriptionText>
            </TableCell>
            <TableCell color={colors.text}>
                <ProductTextBlock>
                    <div style={{display: 'flex', alignItems: 'center', gap: 6}}>
                        <ValueText color={colors.text}>{props.valueText ?? formatCurrency(props.value)}</ValueText>
                        {props.valueLabel && (
                            <DescriptionText color={colors.hint}>{props.valueLabel}</DescriptionText>
                        )}
                    </div>
                    {props.valueNote && (
                        <DescriptionText color={colors.hint}>{props.valueNote}</DescriptionText>
                    )}
                </ProductTextBlock>
            </TableCell>
            <TableCell color={colors.text}>
                <ActionCellContent>
                    {props.statusAndButton.button}
                </ActionCellContent>
            </TableCell>
        </TableRow>
    )
};

export default SubscriptionOverviewRow;
